export { SGWTConnectCore as SGWTConnect } from '@sgwt/connect-core';
